export default "__VITE_ASSET__Bqu48LJJ__"